import { bindable, autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { Account } from '../../models/customer';
import { State } from '../../services/global-state';
import { DialogService } from 'aurelia-dialog';
import { I18N } from 'aurelia-i18n';
import { PayrazrService } from '../../services/payrazr';
import { CancelRecurringDialog } from './cancel-recurring.dialog';

@autoinject
export class ViewRecurring {
	account: Account;
	allowSkippingOfPayments: boolean = false;
	showActionsButton: boolean = false;
	plan:any;

	constructor(private state: State, private payrazrService: PayrazrService, private router: Router, private dialogService: DialogService, private i18n: I18N) {

	}

	activate(params) {
		this.account = this.state.accounts.find((element, index, array) => {
			return element.id === params.id;
		});
		this.state.business.applyPortfolioSettingsToPortal(this.account.portfolioName, false);

		let portfolioPortalSettings = this.state.business.fetchPortfolioSettings(this.account.portfolioName).settings;

		this.allowSkippingOfPayments = portfolioPortalSettings.paymentTypes.allowConsumersToSkipAPayment || false;
		this.showActionsButton = this.allowSkippingOfPayments;
	}

	goBack() {
		this.router.navigateBack();
	}

	showError(message: string) {
		alert(message); // TODO: use somethign other than alerts
	}

	cancelPlan() {
		this.dialogService.open({ viewModel: CancelRecurringDialog, lock: false })
			.whenClosed(response => {
				if (!response.wasCancelled) {
					// This is a HUGE assumption. There can only ever be a single plan on an account int portal. This may cause issues in the future if that changes
					this.payrazrService.cancelPaymentPlan(this.account.paymentPlans[0].id).then(
						(result) => {
							if (result === true) {
								this.router.navigate('');
							} else {
								this.showError(this.i18n.i18next.t('recurringCancellationFailed', 'Failed to cancel recurring plan'));
							}
						},
						(error) => {
							this.showError(this.i18n.i18next.t('recurringCancellationFailed', 'Failed to cancel recurring plan'));
						}
					);
				}
			});
	}

	skipPayments() {
		let route = this.router.routes.find(
			x => x.name === 'skipPlanPayments'
		);

		route.accountId = this.account.id;

		this.router.navigateToRoute(route.name);
	}
}
